import { render } from "./PrivacyP.vue?vue&type=template&id=ceb74136&scoped=true"
import script from "./PrivacyP.vue?vue&type=script&lang=js"
export * from "./PrivacyP.vue?vue&type=script&lang=js"

import "./PrivacyP.vue?vue&type=style&index=0&id=ceb74136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb74136"]])

export default __exports__